import type {Award,Card,Snapshot} from '@platform/contracts/x';
import type {CardPrizeStates} from '@platform/ui/CardPlayFooter';

// Match the room rail using the offered draw's server state and frozen JP limit.
// Completed describes the stage; card membership AND its allocated payout describe a win.
export function cardPrizeStates(state:Snapshot):CardPrizeStates {
 const cancelled=state.status==='Cancelled'||state.tombala.status==='Cancelled';
 const finished=state.status==='Completed'||state.tombala.status==='Completed';
 const limit=state.x.jackpotBallLimit,drawn=state.balls.at(-1)?.sequence??0;
 return Object.fromEntries(state.prizes.map(p=>[p.id,cancelled?'unavailable':p.awarded?'completed':
  finished||p.id==='jackpot'&&limit>0&&drawn>limit?'unavailable':
  state.status==='Live'&&state.tombala.status==='Live'&&p.id===state.tombala.nextStageId?'active':'upcoming']));
}
export function cardWonStages(card:Card,awards:Award[]):string[]{
 return card.ownMinor>0?awards.filter(a=>a.cardIds.includes(card.id)&&(card.prizeShares?.[a.stage]??0)>0).map(a=>a.stage):[];
}

// A quoted return or zero remaining balls alone is not an awarded prize.
// Stable partition keeps the existing order within winners and other cards.
export function prioritizeWinningCards(cards:Card[],awards:Award[]):Card[]{
 const winners=new Set(cards.filter(card=>cardWonStages(card,awards).length>0).map(card=>card.id));
 return [...cards].sort((a,b)=>Number(winners.has(b.id))-Number(winners.has(a.id)));
}
